import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "extranet-component-library";
import walletB from "../assets/img/cards/MONEDERO_B.svg";
import TableWallet from '../components/TableWallet';
import WalletMobile from '../components/WalletMobile';
import WalletCard from '../components/WalletCard';
import { useStores } from "../hooks/useStores";
import { usePdfDownload } from "../hooks/usePdfDownload";
import { openPdfInNewWindow } from "../utils/pdfService";
import { formatTimestamp } from "../utils/dateFormatter";

/**
 * Wallet Component
 * 
 */
const Wallet = observer(() => {
  const { t } = useTranslation();
  const { myTimStore, myTibStore } = useStores();
  const { getWalletOperations, capping, walletOperations, headersWalletOpertations, card } = myTimStore;
  const { getUserHistoryReport } = myTibStore;
  const operations = Array.isArray(walletOperations) ? walletOperations : [];
  const hasOperations = operations.length > 0;
  
  const totalItems = parseInt(headersWalletOpertations.totalresults, 10);
  
  // Generación del nombre de archivo con timestamp
  const filename = `historial-${formatTimestamp()}`;
  
  // Hook personalizado que encapsula la lógica de descarga (SRP + DIP)
  const { isDownloading, downloadPdf } = usePdfDownload(
    getUserHistoryReport,
    openPdfInNewWindow,
    filename
  );

  return (
    <>
      <div data-testid="data">
        <div className="page-title-mobile">
          {t("carnet").replace("/", " ")}
          <img src={walletB} alt="img" />
        </div>
        <WalletCard movements={operations} carnet={card} capping={capping} />
        <div style={{ margin: "3rem 2rem 0.5rem 2rem", display: "flex", justifyContent: "flex-end" }}>
          <PrimaryButton
            text={t("download_history_pdf")}
            onClick={downloadPdf}
            disabled={isDownloading}
          />
        </div>
        {hasOperations ? (
          <div>
            <TableWallet movements={operations} totalItems={totalItems} getMoreData={getWalletOperations} />
            <WalletMobile movements={operations} totalItems={totalItems} getMoreData={getWalletOperations} />
          </div>
        ) : (
          <div data-testid="no-data" className="no-items">
            {t("no_items")}
          </div>
        )}
      </div>
    </>
  );
});

export default Wallet;
